import React from 'react';

interface PlayerData {
  msg: string;
  code: string;
  persid: string;
  detail_string: string;
  event_price: number;
  homeclub_id: string;
  title: string;
  firstname: string;
  lastname: string;
  handicap: number;
  gender: string;
  birthdate: string;
  is_substitude: boolean;
  club_country_number: string;
}

const LeagueReportEvents: React.FC<{
  data: PlayerData[];
}> = ({ data }) => {
  return (
    <>
      <div className="max-h-[400px] grid gap-1 overflow-scroll text-sm">
        <div className="flex gap-2 sticky top-0 bg-white shadow-lg py-2">
          <div className="flex gap-2 py-2 flex-1 items-center">
            <div className="text-2xl ml-4"> 🏌️</div>
            <div className="flex-1">
              <div className="text-2xl font-medium">{data.length}</div>
              <div> Spieleranzahl </div>
            </div>
          </div>
        </div>
        {data.map((player, index) => (
          <div
            key={index}
            className="border-b items-center flex gap-2 py-2 hover:bg-gray-50"
          >
            <div className="text-2xl font-thin w-10 text-center">
              {index + 1}
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <div className="font-bold">{player.msg}</div>
                <div className="mr-2 font-medium">{player.code}</div>
              </div>
              <span>{player.persid}</span> <span> {player.detail_string} </span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default LeagueReportEvents;
